import technologiesData from '../datas/technologies.json';
import deprecatedTechnologiesData from '../datas/deprecated-technologies.json';
export const deprecatedTechnologies = deprecatedTechnologiesData;
export const technologies = technologiesData;
